import { IFormField } from "../web-form.objects"
import _ from "lodash";
import { JsonItem } from "../../../entities/pick-list/pick-list.entities";

export class NumberInputOptions {
    isInteger: boolean = false;
    minValue: number = undefined;
    maxValue: number = undefined;
    constructor(isInteger: boolean = false, minValue: number = undefined, maxValue: number = undefined) {
        this.isInteger = isInteger;
        this.minValue = minValue;
        this.maxValue = maxValue;
    }
}

export class NumberInputField implements IFormField {
    fieldId: string; 
    displayName: string; 
    description: string;
    isRequired: boolean;
    propertyName: string; 
    defaultVal: any; 
    initialVal: any;

    options: NumberInputOptions;

    constructor(propertyName: string, fieldId: string, displayName: string, description: string, isRequired: boolean, options: NumberInputOptions = new NumberInputOptions()) {
        this.fieldId = fieldId;
        this.displayName = displayName;
        this.description = description;
        this.isRequired = isRequired;
        this.propertyName = propertyName;
        
        this.options = options;

        this.defaultVal = 0;
        this.initialVal = 0;
    }

    generateHtml(): string {
        let requiredClass = "";
        if (this.isRequired) requiredClass = "required";

        let html = `
            <label for="" class="${requiredClass}">${this.displayName}</label>
            ${this.description != "" ? `<p class='form-text'>${this.description}</p>` : ``}
            <input type="number" class="form-control col-12" id="${this.fieldId}">
        `;

        return html;
    }

    initialize() {
        $(`#${this.fieldId}`).on("change keyup", () => {
            $(`#${this.fieldId}`).trigger("form-field-change");
        });
    }

    setOptions(pickLists: JsonItem[]) {
        return;
    }

    prepopulate(items: any[]): void {
        this.initialVal = this.defaultVal;
        // Check if all have valid
        let isValid = items.every(item => _.get(item, this.propertyName));

        if (isValid) {
            // Check if all are the same
            if (items.every((item, i, arr) => _.get(item, this.propertyName) == _.get(arr[0], this.propertyName)) && items.length > 0) {
                this.initialVal = _.get(items[0], this.propertyName);
            }
        }

        this.setInput(this.initialVal);
    }

    updateItem(item: any): any {
        let updatedItem = _.cloneDeep(item);
        _.set(updatedItem, this.propertyName, this.getValue());
        return updatedItem;
    }

    private getInput(): string {
        let input = (<string>$(`#${this.fieldId}`).val()).trim();
        return input;
    }

    private setInput(data: any): void {
        $(`#${this.fieldId}`).val(data);
    }

    private getParsedInput(): number {
        let input = this.getInput();
        if (this.options.isInteger) {
            let val = parseInt(input);
            if (val) {
                return val;
            }
        }
        else {
            let val = parseFloat(input);
            if (val) {
                return val;
            }
        }

        return this.defaultVal;
    }

    getValue(): any {
        let val = this.initialVal;

        let isValid = this.checkValid();
        let isChanged = this.checkChanged();
        if (isValid && isChanged) {
            val = this.getParsedInput();
        }

        return val;
    }

    setValue(formData: any) {
        let formVal = _.get(formData, this.propertyName);
        if (formVal != undefined) {
            this.setInput(formVal);
        }
    }

    checkValid(): boolean {
        let val = this.getParsedInput();

        // min/max
        if (this.options.minValue != undefined) {
            if (val < this.options.minValue) {
                return false;
            }
        }
        if (this.options.maxValue != undefined) {
            if (val > this.options.maxValue) {
                return false;
            }
        }      

        if (this.isRequired) {
            let input = this.getInput();
            // empty
            if (!input) {
                return false;
            }
            return true;
        }
        else {
            return true;
        }
    }

    checkChanged(): boolean {
        let val = this.getParsedInput();
        if (val != this.initialVal) {
            return true;
        }
        return false;
    }

    displayValid(isValid: boolean) {
        if (isValid) {
            $(`#${this.fieldId}`).addClass("is-valid").removeClass("is-invalid");
        }
        else {
            $(`#${this.fieldId}`).removeClass("is-valid").addClass("is-invalid");
        }
    }

    resetValidDisplay() {
        $(`#${this.fieldId}`).removeClass("is-valid").removeClass("is-invalid");
    }

    compareItems(item1: any, item2: any): boolean {
        let x1 = <number>_.get(item1, this.propertyName);
        let x2 = <number>_.get(item2, this.propertyName);
        return x1 == x2;
    }

    generateChangeHtml(newItem: any, prevItem: any): string {
        let isChanged = false;

        if (prevItem == undefined) {
            isChanged = true;
        }
        else {
            isChanged = !this.compareItems(newItem, prevItem);
        }

        if (!isChanged) {
            return "";
        }

        let changeContent = "";

        let newVal = _.get(newItem, this.propertyName);
        if (newVal) {
            let newDisplay = `
                    <div class="new-change-block change-block">
                        <div class="col-auto">
                            <i class="fa-solid fa-plus new-change-icon"></i>
                        </div>
                        <div class="col">
                            ${newVal}
                        </div>
                    </div>
                `;
            changeContent = newDisplay;
        }

        if (prevItem != undefined) {
            let prevVal = _.get(prevItem, this.propertyName);
            if (prevVal) {
                let prevDisplay = `
                        <div class="delete-change-block change-block">
                            <div class="col-auto">
                                <i class="fa-solid fa-trash-can delete-change-icon"></i>
                            </div>
                            <div class="col">
                                ${prevVal}
                            </div>
                        </div>
                    `;
                changeContent += prevDisplay;
            }
        }

        let html = `
                <div class="change-content-block">
                    <div class="change-content-label">
                        ${this.displayName}
                    </div>
                    ${changeContent}
                </div>
            `;

        return html;
    }
}

